const initialState = false;

const ReservationProductSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationProductSave":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationProductSaveReducer;
